var SENTRY_RELEASE;SENTRY_RELEASE={name: "Nomadas Chat", version: "1.4.6"};